{
    "SectionheaderDatetime": "Terminzeit",
    "SectionheaderTimerange": "Zeitspanne",
    "SectionheaderDaterange": "Benutzerdefinierter Datums-\/Zeitbereich",
    "SectionheaderDaysoftheweek": "Tage der Woche",
    "InputlabelBetween": "Zwischen:",
    "InputlabelAnd": "Und:",
    "RadiolabelRealtime": "Echtzeit (Jetzt)",
    "RadiolabelToday": "Heute",
    "RadiolabelYesterday": "Gestern",
    "RadiolabelThisweek": "In dieser Woche",
    "RadiolabelLastweek": "Letzte Woche",
    "RadiolabelThismonth": "Diesen Monat",
    "RadiolabelLastmonth": "Im vergangenen Monat",
    "RadiolabelCustom": "Brauch...",
    "RadiolabelDays": "Tage:",
    "NAME": "DateTime",
    "SectionHeaderLastXDays": "Letzte 'X' Tage",
    "RadiolabelLastXDays": "Letzte 'X' Tage"
}